import { useBubbleChat } from '@src/clientUser/bubbleChat/useBubbleChat';
import { clientUsersRouter } from '@src/clientUser/ClientUsersRouter';
import { RouterProvider } from 'react-router-dom';

export const ClientUserApp = () => {
  useBubbleChat();

  return <RouterProvider router={clientUsersRouter} />;
};
